module.exports = __webpack_public_path__ + "img/dashboards-navbar-issues.784673a2.svg";